import {CategorieDto} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {Component} from "@angular/core";
import {CategoriesStore} from "@common/store/categories.store";

@Component({
  selector: 'categories',
  templateUrl: './categories.component.html',
  host: {'class': 'page'}
})
export class CategoriesComponents {
    constructor(private categoriesStore: CategoriesStore, private activatedRoute: ActivatedRoute) {
  }

    ngOnInit() {
        let categories = this.activatedRoute.snapshot.data['categories'];
        this.categoriesStore.setCategories(categories);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/categories.component.ts